import React, { FC } from 'react'
import cx from 'classnames'

import { HeaderProps } from '../../components/Header'
import { FooterProps } from '../../components/Footer'

import * as SC from './styled'

export type DefaultLayoutProps = {
  className?: string
  header?: HeaderProps
  footer?: FooterProps
  children?: React.ReactNode
}

const DefaultLayout: FC<DefaultLayoutProps> = ({
  children,
  className,
  header = null,
  footer = null,
}) => {
  return (
    <SC.Container className={cx(className)}>
      {header && <SC.Header {...header} />}
      {children}
      {footer && <SC.Footer {...footer} />}
    </SC.Container>
  )
}

export default DefaultLayout
